import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {SelectInput} from 'admin-on-rest';
import LocationFilter from "./LocationFilter";
import {convertDate} from '../shared/functions';
import FormattedDateTextInput from './FormattedDateTextInput';
import {TIME_ZONE_OFFSETS} from '../shared/dateTimeLists';
import {filterStyles} from '../shared/styles-filter';
import RaisedButton from 'material-ui/RaisedButton';

/**
 * A form containing a SelectInput component with Mode choices
 *
 */
class DailySalesReportsFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayDateFilter: false,
            locationsList: [],
            selectedLocation: null,
            selectedDay: null,
            selectedOffset: (props.selectedOffset) ? props.selectedOffset : null,
            zeroDayOptionsList: [],
            zeroDaysList: [],
        };
        this.handleDaySelect = this.handleDaySelect.bind(this);
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.handleOffsetSelect = this.handleOffsetSelect.bind(this);
        this.handleClear = this.handleSubmit.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setLocationList = this.setLocationList.bind(this);
    }

    /**
     * Store Locations sent by Location Filter
     *
     * @param list
     */
    setLocationList(list) {
        this.setState({
            locationsList: list
        });
    }

    /**
     * Handle selection event for Location
     *
     * @param event
     * @param index
     * @param value
     */
    handleLocationSelect(event, index, value) {
        if (index) {
            // Extract the full Location object from the selected location_id
            const locationObj = this.state.locationsList.find(r => r.id.toString() === index.id.toString());
            if (locationObj) {
                this.setState({
                    selectedLocation: locationObj,
                }, () => {
                    this.props.dispatch(change('filterForm', 'location', locationObj));
                    if (typeof this.props.onClear === 'function') {
                        this.props.onClear();
                    }
                });
            }
        }
    }

    /**
     * Handle selection event for Day
     *
     * @param event
     * @param index
     * @param value
     */
    handleDaySelect(event, index, value) {
        if (index && index !== value) {
            // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
            const dateStr = convertDate(index, 'query', false, true);
            this.setState({
                    selectedDay: dateStr
                }, () => {
                    this.props.dispatch(change('filterForm', 'day', dateStr));
                if (typeof this.props.onClear === 'function') {
                    this.props.onClear();
                }
                }
            );
        }
    }

    /**
     * Handle selection event for Time Zone Offset
     *
     * @param event
     * @param index
     * @param value
     */
    handleOffsetSelect(event, index, value) {
        if (index && index !== value) {
            this.setState({
                selectedOffset: index
            }, () => {
                this.props.dispatch(change('filterForm', 'offset', index));
                if (typeof this.props.onClear === 'function') {
                    this.props.onClear();
                }
            });
        }
    }

    handleSubmit() {
        const selectedLocation = this.state.selectedLocation;
        const selectedDay = this.state.selectedDay;
        const offset = this.props.selectedOffset;
        if (typeof this.props.onSubmit === 'function') {
            this.props.onSubmit(selectedLocation, selectedDay, offset);
        }
    }

    render() {
        const {
            selectedOffset
        } = this.props;

        const {
            selectedLocation,
            selectedDay
        } = this.state;

        const styles = {
            button: {display: 'inline-block', margin: '0.5em 0 0 0'},
            field: {display: 'block', maxWidth: '80%'},
        };

        const disableButton = (!selectedDay || !selectedLocation || !selectedOffset);

        return (
            <div className="list-filter">
                <LocationFilter
                    label="Select a Location:"
                    onLocationsLoaded={this.setLocationList}
                    onSelectLocation={this.handleLocationSelect}
                    selectionType="object"
                />
                <form>
                    <div className="list-filter">
                        <FormattedDateTextInput
                            name="day"
                            source="day"
                            label="Select a Day:"
                            onChangeFunc={this.handleDaySelect}
                            maxDate={new Date()}
                        />
                        <Field name="offset"
                               component={SelectInput}
                               label="Select a Time Zone Offset"
                               choices={TIME_ZONE_OFFSETS}
                               onChange={this.handleOffsetSelect}
                               elStyle={filterStyles.selectInput}
                               options={{
                                   value: selectedOffset
                               }}
                        />
                    </div>
                    <RaisedButton
                        primary
                        label="Submit"
                        onClick={this.handleSubmit}
                        disabled={disableButton}
                        style={styles.button}
                    />
                </form>
                <hr style={filterStyles.break}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let filterForm = state.form['filterForm'];
    let timeZoneForm = state.form['timeZoneForm'];
    const defaultOffsetValue = (timeZoneForm && timeZoneForm.values && timeZoneForm.values['timeZoneDefault']) ? timeZoneForm.values['timeZoneDefault'] : null;
    if (filterForm) {
        const offsetValue = (filterForm.values && filterForm.values['offset']) ? filterForm.values['offset'].toString() : defaultOffsetValue;
        return {
            selectedOffset: offsetValue
        };
    }
    return {};
}

DailySalesReportsFilter.propTypes = {
    onClear: PropTypes.func,
    onSubmit: PropTypes.func
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'filterForm',
        enableReinitialize: true,
    })
);

export default enhance(DailySalesReportsFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/DailySalesReportsFilter.js